// removed by extract-text-webpack-plugin
module.exports = {"titleContainer":"ztavcAtkgr155g9RjwOUF","title":"_28-TVqnOSiCDqouXITl7bh","subtitle":"_2hoR5Op3cWqPEBWrLvr6Ym","image":"_1ctX9Oqfcn5KF48aoTu_ky","informations":"_2FGZHYASsAyhaWYVkCzh7M","profilePic":"B3Lm__rrpXksprw_F8TRQ","empty":"_1w68CiS6vXQSgmzCip1l7r","loading":"_1fNL7X9C_KvhbY4NCZtVei","outfits":"QWgZS4O50B9Yw6QSRET7c","loader":"_3rWOHVp_aFifzokeVkia8j","load8":"_1euhxUBy42F7Ry8oJrVgo"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/AdminDiscover/AdminDiscover.scss
 ** module id = 741
 ** module chunks = 0
 **/